import DataLoader from "../Utlis/DataLoader";

const Getcomments = async (id) => {
  try {
    const response = await DataLoader({
      Path: `/api/v1/comments/filtercomment/${id}`,
      Type: "get",
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export default Getcomments;
